"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frontEndValidator = exports.passwordlessFrontEndValidator = exports.backEndValidator = void 0;
const schema_1 = require("../../schema");
const occupation_1 = require("../../concepts/occupation");
const language_1 = require("../../concepts/language");
const stampNumber = schema_1.Schema.stampNumber();
const validator = schema_1.Schema.object()
    .properties({
    title: schema_1.Schema.string().optional(),
    firstName: schema_1.Schema.string(),
    lastName: schema_1.Schema.string(),
    phoneNumber: schema_1.Schema.phoneNumber(),
    occupation: occupation_1.occupation.default(occupation_1.Occupation.Doctor),
    stampNumber: schema_1.Schema.ifThenElse(schema_1.Schema.expression(`{../occupation} === "${occupation_1.Occupation.Doctor}"`), stampNumber, stampNumber.forbidden()),
    defaultLanguage: language_1.language.default(language_1.Locale.HU)
})
    .sealed()
    .default({});
exports.backEndValidator = validator.properties({
    token: schema_1.Schema.string(),
    password: schema_1.Schema.string().minLength(8)
});
exports.passwordlessFrontEndValidator = validator.properties({
    email: schema_1.Schema.string(),
    organization: schema_1.Schema.string(),
    module: schema_1.Schema.string()
});
exports.frontEndValidator = exports.passwordlessFrontEndValidator.properties({
    password: schema_1.Schema.string().minLength(8),
    passwordAgain: schema_1.Schema.const(schema_1.Schema.reference("../password"))
});
